<template>
  <el-upload
    action="https://gateway.cbyyk.com/product/goodsbase/upload"
    :file-list="fileList"
    :limit="2"
    :multiple="false"
    :on-success="handleFileList"
    :on-remove="handleRemove"
    :before-upload="beforeAvatarUpload"
    :accept="accept"
  >
    <div class="fileUpload">
      <div class="text">{{ text }}</div>
      <div class="btn">点击上传</div>
      <div slot="tip" class="el-upload__tip">{{ tips }}</div>
    </div>
  </el-upload>
</template>
<script>
export default {
  name: "SimpleFileUpload",
  props: {
    accept: {
      default: ".jpeg,.jpg,.png,.pdf",
    },
    fileList: {
      default: () => [],
    },
    text: {
      default: "示例",
    },
    tips: {
      default: "上传pdf或图片，且不超过10M",
    },
  },
  methods: {
    handleFileList(response, file, fileList) {
      const { name } = file;
      const { url } = file?.response?.data;
      if (url) {
        this.$emit("handleFileList", [{ name, url }]);
        this.$message.success("上传成功");
      }
    },
    handleRemove() {
      this.$emit("handleFileList", []);
    },
    beforeAvatarUpload(file) {
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isLt10M) {
        this.$message.error("上传文件大小不能超过 10MB!");
      }
      return isLt10M;
    },
  },
};
</script>
<style scoped>
.fileUpload {
  display: flex;
  color: #606266;
  align-items: center;
}
.btn {
  background-color: red;
  color: #ffffff;
  border-radius: 4px;
  margin: 0 5px;
  padding: 2px 10px;
  font-size: 12px;
}
.text {
  color: #606266;
  font-size: 13px;
}
</style>